<template>
  <div class="outer-hg-100">
    <div class="info-content" ref="scrollInfoContent"> 
      <div class="make-title">Make Your Test</div>
      <div class="test-name-row">
        <div class="test-name-col">
          <div class="test-name test-name-1">Test Name</div>
          <div class="mock-test-text">{{ stepOneData.testName }}</div>
        </div>
        <div class="test-name-col">
          <div class="test-name test-name-1">Target Exam</div>
          <div class="mock-test-text">
            {{ stepOneData.targetSelected.text }}
          </div>
        </div>
      </div>
      <div class="test-name">Subjects</div>
      <div class="card-panel">
        <div class="jee-user-row-cust">
          <div
            class="card-data"
            :style="item.checked ? { border: '1px solid #089BE5' } : ''"
            v-for="(item, index) in items"
            :key="index"
          >
            <img
              :src="
                require('@/assets/img/myttargetexamicon/' + item.text + '.svg')
              "
              class="card-icon"
            />
            <div class="card-title physics">{{ item.text }}</div>
            <v-checkbox
              v-model="item.checked"
              color="secondary-darken-3"
              @change="getSelectedSubject(item)"
            >
            </v-checkbox>
          </div>
        </div>
      </div>
      <div class="myt-dropdown add-ch-arrow practice-session-drop-outer">
        <div class="test-name test-top-20">Difficulty</div>
        <div
          class="practice-session-drop-down"
          v-if="selectedSubjectWithDifficultyLevel"
        >
          <div
            class="field-data"
            v-for="(item, index) in selectedSubjectWithDifficultyLevel"
            :key="index"
          >
            <label>{{ item.text }}</label>
            <v-select
              v-model="item.difficulty"
              :items="difficultyLevels"
              item-text="title"
              item-value="id"
              hide-details
              dense
              outlined
              class="required fix-140-width selected-drop-border-myt"
              :class="item.difficulty ? 'selected-border-myt' : ''"
            >
            </v-select>
          </div>
        </div>
      </div>
      <div class="myt-dropdown selectedPatterns">
        <div class="test-name test-top-20 pattern-step-4">Pattern</div>
        <div class="input-radio-row">
          <v-radio-group
            v-model="selectedPatterns"
            class="input-radio-row-outer"
          >
            <div
              class="input-radio"
              :class="
                selectedPatterns === item.value.id ? 'selected-border-myt' : ''
              "
              v-for="(item, index) in patterns"
              :key="index"
            >
              <!--v-text-field
                disabled
                v-model="item.text"
                dense
                outlined
                hide-details
                class="radio-input-bg"
                :value="item.text"
              ></v-text-field-->
              <div class="input-view">{{ item.text }}</div>
              <div class="radio-drop-myt">
                <v-radio
                  color="secondary-darken-3"
                  :value="item.value.id"
                ></v-radio>
              </div>
            </div>
            <div
              class="input-radio"
              :class="
                selectedPatterns == 'custom-pattern'
                  ? 'selected-border-myt'
                  : ''
              "
            >
              <!--v-text-field
                disabled
                value="Custom Pattern"
                dense
                outlined
                hide-details
                class="radio-input-bg"
                >Custom Pattern</v-text-field
              -->
              <div class="input-view">Custom Pattern</div>
              <div class="radio-drop-myt">
                <v-radio
                  value="custom-pattern"
                  color="secondary-darken-3"
                ></v-radio>
              </div>
            </div>
          </v-radio-group>
        </div>
      </div>
    </div>
    <div class="footer-btn">
      <div></div>
      <div v-if="selectedPatterns === 'custom-pattern'">
        <v-btn
          color="primary"
          class="cust-btn myt-next"
          @click="
            onCustomizeClick({
              stepOneData: stepOneData,
              stepTwoData: stepTwoData,
              stepThreeData: stepThreeData,
              stepFourData: getStepFourData(false)
            })
          "
        >
          Next
        </v-btn>
      </div>
      <div v-else>
        <v-btn
          color="primary"
          class="cust-btn myt-syllabus myt-other-button"
          @click="
            onCustomizeClick({
              stepOneData: stepOneData,
              stepTwoData: stepTwoData,
              stepThreeData: stepThreeData,
              stepFourData: getStepFourData(true)
            })
          "
        >
          Customize Syllabus
        </v-btn>
        <v-btn
          color="primary"
          class="cust-btn myt-other-button"
          @click="
            onNextClick({
              stepOneData: stepOneData,
              stepTwoData: {
                selectedSubjects,
                selectedSubjectWithDifficultyLevel
              },
              stepThreeData: stepThreeData,
              stepFourData: getStepFourData(false)
            })
          "
        >
          Create Full Test
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import constants from "../../../../utils/constants";

export default {
  props: [
    "onNextClick",
    "stepOneData",
    "stepTwoData",
    "stepThreeData",
    "onCustomizeClick",
    "data"
  ],
  name: "StepFourData",
  data() {
    return {
      e1: 1,
      selectedDifficulty: [],
      items: [],
      difficultyLevels: constants.DIFFICULTY_LEVELS,
      selectedSubjectWithDifficultyLevel: [],
      selectedSubjects: [],
      patterns: [],
      selectedPatterns: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.scrollInfoContent.scrollTop = this.$refs.scrollInfoContent.scrollHeight;
      if(window.innerWidth < 991){
        let scrollElem = document.getElementsByClassName("pattern-step-4");
        document.body.scrollTop = document.documentElement.scrollTop = scrollElem[0].offsetTop + 50;
      }else{
        document.body.scrollTop = document.documentElement.scrollTop = document.body.scrollHeight;
      }
    });
    if (this.stepOneData) {
      if (this.stepOneData.targetSelected) {
        this.reqGetTestPattern();
      }
    }
    if (this.stepTwoData) {
      if (this.stepTwoData.subjects) {
        this.items = this.stepTwoData.subjects;
      }
      if (this.stepTwoData.selectedSubjectWithDifficultyLevel) {
        this.selectedSubjectWithDifficultyLevel = this.stepTwoData.selectedSubjectWithDifficultyLevel;
      }
      if (this.stepTwoData.selectedSubjects) {
        this.selectedSubjects = this.stepTwoData.selectedSubjects;
      }
    }
  },
  methods: {
    ...mapActions({
      getTestTarget: "utilStore/getTestTarget",
      getMYTTestPatterns: "utilStore/getMYTTestPatterns",
      createCustomTestAPI: "testStore/createCustomTest",
      getDataTreeWithLevelPublic: "utilStore/getDataTreeWithLevelPublic"
    }),
    reqGetTestPattern() {
      this.selectedPatterns = null;

      if (this.data && this.data.targetSelected) {
        this.selectedPatterns = this.data.targetSelected;
      }
      this.getMYTTestPatterns({
        test_target_id: this.stepOneData.targetSelected.value,
        myt_pattern: true
      })
        .then((response) => {
          this.loading = false;
          this.patterns = response.map((x) => {
            let c = {};
            c.text = x.pattern_name;
            c.value = x;
            c.value.test_params = JSON.parse(c.value.test_params);
            c.checked = false;
            return c;
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getSelectedSubject(item) {
      if (item.checked) {
        this.selectedSubjects.push(item);
      } else {
        let index =
          this.selectedSubjects &&
          this.selectedSubjects.length &&
          this.selectedSubjects.findIndex((x) => x.value.id === item.value.id);
        this.selectedSubjects &&
          this.selectedSubjects.length &&
          this.selectedSubjects.splice(index, 1);
      }
      this.onSelectSubject();
    },
    onSelectSubject() {
      if (this.selectedSubjects && this.selectedSubjects.length > 0) {
        this.selectedSubjectWithDifficultyLevel = this.selectedSubjectWithDifficultyLevel.filter(
          (item) => {
            return this.selectedSubjects.find((s) => {
              return s.value.id == item.value.id;
            });
          }
        );
        this.selectedSubjects.map((item) => {
          const e = this.selectedSubjectWithDifficultyLevel.find((s) => {
            return s.value.id == item.value.id;
          });
          if (!e) {
            this.selectedSubjectWithDifficultyLevel.push(item);
          }
        });
      } else {
        this.selectedSubjectWithDifficultyLevel = [];
      }
    },
    getStepFourData(customize) {
      let selectedPatterns = this.patterns.find(
        (p) => p.value.id === this.selectedPatterns
      )?.value;
      return {
        selectedPatterns: selectedPatterns
          ? selectedPatterns
          : this.selectedPatterns,
        targetSelected: this.selectedPatterns,
        customize
      };
    }
  },
  watch: {
    stepOneData(val) {
      if (val) {
        if (val.targetSelected) {
          this.reqGetTestPattern();
        }
      }
    },
    stepTwoData(val) {
      if (val) {
        if (val.subjects) {
          this.items = val.subjects;
        }
        if (val.selectedSubjectWithDifficultyLevel) {
          this.selectedSubjectWithDifficultyLevel =
            val.selectedSubjectWithDifficultyLevel;
        }
        if (val.selectedSubjects) {
          this.selectedSubjects = val.selectedSubjects;
        }
      }
    }
  }
};
</script>
